import { useTranslation } from '@lyearn/i18n';
import { AlertTriangleOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack, Tooltip, TooltipProps, Typography, TypographyType } from '@lyearn/ui';

export type AIDisclaimerProps = {
  classes?: {
    root?: string;
    icon?: string;
  };
  typographyProps?: Pick<TypographyType, 'color' | 'variant'>;
  tooltipProps?: { className?: string; placement?: TooltipProps['placement'] };
  variant?: 'default' | 'tooltip';
};

function AIDisclaimer(props: AIDisclaimerProps) {
  const { classes, typographyProps, variant, tooltipProps } = props;
  const { t } = useTranslation('AI');

  const icon = (
    <AlertTriangleOutline
      className={cn('h-20 w-20 text-icon-placeholder hover:text-icon-secondary', classes?.icon)}
    />
  );

  if (variant === 'tooltip') {
    return (
      <Stack alignItems="center" className={cn('gap-x-8', classes?.root)}>
        <Tooltip
          PopperProps={{
            className: cn('w-[166px] text-center', tooltipProps?.className),
          }}
          placement={tooltipProps?.placement}
          title={t('AI:AIResponsesCanBeInaccurateMisleading')}>
          <Box>{icon}</Box>
        </Tooltip>
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" className={cn('gap-x-8', classes?.root)}>
      {icon}
      <Typography
        color={typographyProps?.color ?? 'text-text-placeholder'}
        variant={typographyProps?.variant ?? 'body-short-02'}>
        {t('AI:AIResponsesCanBeInaccurateMisleading')}
      </Typography>
    </Stack>
  );
}

export default AIDisclaimer;
